import { useLocation } from 'react-router'
import { getWindowBrowser } from './origin'
import buildParams from 'api/requests/config-builder'
import * as paths from 'routes/paths'

type LocationState = { referrer?: string }

type redirectToSsoUrLParams = {
  redirectUrl: string
  location: ReturnType<typeof useLocation<LocationState>>
}

export const redirectToSsoUrL = ({ redirectUrl, location }: redirectToSsoUrLParams) => {
  const searchParams = new URLSearchParams(location?.search)
  const source = searchParams.get('source')
  let ssoRedirectUrl = redirectUrl

  const originQueryParams = buildParams({
    token: undefined,
    params: {
      origin: 'web',
      origin_meta: {
        browser: getWindowBrowser(),
        referrer_path: paths.WEB_SSO,
        user_agent: window.navigator.userAgent,
        language: window.navigator.language,
        platform: window.navigator.platform,
        vendor: window.navigator.vendor,
        window_height: window.screen.height,
        window_width: window.screen.width,
        referrer_query_parameters: location?.state?.referrer ? `post_sso_referrer=${location?.state?.referrer}` : '',
        ...(source ? { source } : {}),
      },
    },
  })

  if (originQueryParams?.params) {
    ssoRedirectUrl = `${ssoRedirectUrl}&${originQueryParams.params.toString()}`
  }

  window.location.href = ssoRedirectUrl
}
